import { render, staticRenderFns } from "./TelaDeRegrasFiscais.vue?vue&type=template&id=b32b999c&scoped=true&"
import script from "./TelaDeRegrasFiscais.vue?vue&type=script&lang=ts&"
export * from "./TelaDeRegrasFiscais.vue?vue&type=script&lang=ts&"
import style0 from "./TelaDeRegrasFiscais.vue?vue&type=style&index=0&id=b32b999c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b32b999c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VIcon,VTextField})
